import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import { Heading } from '@alefeducation/ui-elements-library-core';
import HeadingWithIcon from './HeadingWithIcon';
import { routes } from './routes';
import isInCCLiframe from '../../utils/isInCCLiframe';

const StyledBreadcrumb = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
  margin-bottom: ${({ theme }: any) => `${theme.space[20]}px`};
`;

export const Breadcrumbs = () => {
  const { params: windowParams, path: windowPath } = useRouteMatch<any>();
  const paramsKeys = Object.keys(windowParams);

  const crumbs = routes
    .filter(({ path }) => windowPath.includes(path))
    .map(({ path, name, ...rest }) => {
      const replacePlaceholderWithValue = () => {
        return paramsKeys.reduce(
          (data: any, param) => {
            const { name, path } = data;

            return {
              name: name.replace(`:${param}`, windowParams[param]),
              path: path.replace(`:${param}`, windowParams[param]),
            };
          },
          { name, path },
        );
      };

      return {
        ...rest,
        ...replacePlaceholderWithValue(),
      };
    });

  if (crumbs.length <= 1) {
    return null;
  }

  return (
    <StyledBreadcrumb>
      {crumbs.map(({ name, path }, index) =>
        index + 1 === crumbs.length ? (
          <Heading key={index} variant="heading-small" weight="light">
            {name}
          </Heading>
        ) : (
          <HeadingWithIcon path={path} key={index}>
            {name}
          </HeadingWithIcon>
        ),
      )}
    </StyledBreadcrumb>
  );
};

export const withBreadcrumbs = <P extends {}>(
  Component: React.ComponentType<P>,
) =>
  class extends React.Component<P> {
    render() {
      return (
        <React.Fragment>
          {!isInCCLiframe && <Breadcrumbs />}
          <Component {...(this.props as P)} />
        </React.Fragment>
      );
    }
  };
